export type ReportBasis = 'entry' | 'event';

export type ReportParams = {
  from: string;
  to: string;
  basis: ReportBasis;
};

const BASE_API_URL = '/api/v1/reports';

export function streamReportDownload(
  params: ReportParams,
  onMessage: (event: MessageEvent) => void,
  onError?: (event: Event) => void,
): EventSource {
  const query = new URLSearchParams(params).toString();
  const es = new EventSource(`${BASE_API_URL}/stream?${query}`, { withCredentials: true });
  es.onmessage = onMessage;
  if (onError) es.onerror = onError;
  return es;
}
